<template>
  <div class="main">
    <main>
      <div class="wrapper">
        <p>
          <span>爱艺术老师端VIP会员服务协议</span>
        </p>
        <p>
          <span>【首部及导言】</span>
        </p>
        <p>
          <span>欢迎您使用爱艺术老师端VIP会员服务！</span>
        </p>
        <p>
          <span>请您在使用爱艺术老师端VIP会员服务（简称为：本服务）前仔细阅读并遵守《爱艺术老师端VIP会员服务协议》（简称为：本协议）。请您务必审慎阅读、充分理解各条款内容，特别是加粗或划线的免除或限制责任的相应条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。</span>
        </p>
        <p>
          <span>您对本服务的任何购买或接受赠与等获取行为即视为您已阅读并同意本协议的约束。</span>
        </p>
        <p>
          <span>如果您不同意本协议的任意或全部条款，请不要以确认的形式</span>
          <span>（包括但不限于点击同意、接受或下一步、进入购买程序、支付费用等）使用本服务。当您点击同意、接受或下一步，或您授权登录、或使用</span>
          <span>爱艺术老师端</span>
          <span>进行任何购买/赠送、或接受赠与、或进行与</span>
          <span>爱艺术老师端</span>
          <span>VIP会员服务相关的交易、或进行观看/搜索/查看/缓存/上传等使用</span>
          <span>爱艺术老师端</span>
          <span>VIP服务及/或</span>
          <span>爱艺术老师端</span>
          <span>刊载内容的行为均视为您已阅读、理解并同意签署本协议 ，表示您与</span>
          <span>浙江艺高文化创意有限公司</span>
          <span>已达成协议关系，并自愿接受并遵守本协议的全部约定。</span>
        </p>
        <p>
          <span>如果您未满18周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款。</span>
        </p>
        <p>
          <span>一、【协议的范围】</span>
        </p>
        <p>
          <span>1.1【协议适用主体范围】</span>
        </p>
        <p>
          <span>本协议是VIP会员与浙江艺高</span>
          <span>文化</span>
          <span>创意有限公司之间关于您成为爱艺术老师端VIP会员且使用爱艺术老师端提供的VIP会员服务所订立的协议，具有法律效力。“VIP会</span>
          <span>员”或“您”是指享受爱艺术老师端提供的VIP会员服务的个人或单一实体。</span>
        </p>
        <p>
          <span>1.2【本服务内容】</span>
        </p>
        <p>
          <span>本协议视为爱艺术老师端《用户注册服务协议》的补充协议，是其不可分割的组成部分，与其构成统一整体。本协议与上述内容存在冲突的，以本协议为准。爱艺术老师端VIP会员涉及的爱艺术老师端产品所有权以及相关软件知识产权归爱艺术老师端所有。爱艺术老师端所提供的服务并按照其服务条款和操作规则严格执行。</span>
        </p>
        <p>
          <span>考虑到互联网服务不断高速发展和演进，您同意浙江艺高</span>
          <span>文化</span>
          <span>创意有限公司有权利对本协议进行修改，协议修改后，浙江艺高文化创意有限公司将通过在相关页面公布修改的内容、通过您注册时提供的通讯工具发送或者其他任何合理方式通知您，您同意承担及时阅读确认修改协议的义务。如果您选择在本协议修改后继续使用会员服务的，则视为您已接受本协议的修改。如果您不同意本协议的修改，尤其是该修改若增加您的义务或缩减您的权利的，请您联系我们，我们将按照公平公正、诚实信用、等价有偿的原则处理后续事宜。</span>
        </p>
        <p>
          <span>您与浙江艺高文化创意有限公司签署的本协议所列明的条款，并不能完全涵盖您与浙江艺高文化创意有限公司所有的权利和义务。您同意浙江艺高文化创意有限公司所公布的其他声明、规则等均视为本协议之补充协议，为本协议不可分割的组成部分，与本协议具有同等法律效力。</span>
        </p>
        <p>
          <span>二、【关于本服务】</span>
        </p>
        <p>
          <span>2.1【</span>
          <span>课程畅学</span>
          <span>】</span>
        </p>
        <p>
          <span>您在开通会员后，可以免费</span>
          <span>收看学习您所购买的会员类型所对应的课程</span>
          <span>，具体内容以线上展示内容为准。</span>
        </p>
        <p>
          <span>2.</span>
          <span>2</span>
          <span>【</span>
          <span>新课上线免费学</span>
          <span>】</span>
        </p>
        <p>
          <span>您在开通会员后，</span>
          <span>您购买的会员所对应的课程分类的新上线课程，也可以免费学习观看</span>
          <span>。</span>
        </p>
        <p>
          <span>2.3【会员专享折扣】</span>
        </p>
        <p>
          <span>您在开通会员后，在购买部分</span>
          <span>其他</span>
          <span>付费</span>
          <span>产品时</span>
          <span>将享有一定的折扣，具体折扣力度以及折扣结算后的会员价格以实际购买时所支付的价格为准。</span>
        </p>
        <p>
          <span>2.</span>
          <span>4</span>
          <span>【会员尊贵标识】</span>
        </p>
        <p>
          <span>您在开通会员服务后，将享有专属身份标识，具体的身份标识信息以爱艺术老师端实际服务页面显示的为准。</span>
        </p>
        <p>
          <span>您理解并同意：上述VIP会员服务内容以爱艺术老师端官方网站公布的会员服务内容为准，爱艺术老师端有权基于自身业务发展需要变更全部或部分会员服务内容，就签署服务内容的变更会在相应的服务页面进行通知或者公告，您也可以通过爱艺术老师端官方网站查询最新的会员权益。</span>
        </p>
        <p>
          <span>您通过爱艺术老师端指定渠道开通本服务后，可能会由于您使用的软件版本、设备、操作系统等不同以及其他第三方原因等导致您实际可使用的具体服务有差别，由此可能给您带来的不便，您表示理解，并不会因此向爱艺术老师端提出任何主张或追究爱艺术老师端的任何责任。</span>
        </p>
        <p>
          <span>三、权利义务</span>
        </p>
        <p>
          <span>3.1【关于收费】</span>
        </p>
        <p>
          <span>3.1.1本服务是爱艺术老师端提供的收费服务，您须在按照本服务的收费标准支付相应费用后，方可使用本服务。此外，您可能也可以通过接受好友赠送等爱艺术老师端认可的其他方式享有、使用部分服务。您知悉并同意，本服务采用先收费后服务的方式，一经开通后不可转让或退款。</span>
        </p>
        <p>
          <span>您理解并同意：爱艺术老师端可能会根据本服务的整体规划，对本服务相关权益细则、收费标准、方式等进行修改和变更，前述修改、变更，爱艺术老师端将在相应服务页面进行展示。您若需要获取、使用本服务，请先提前了解清楚当时关于本服务的收费标准、方式等信息。</span>
        </p>
        <p>
          <span>3.1.2关于额外付费的特别说明：当您成功开通VIP会员服务后，您可以</span>
          <span>学习收看</span>
          <span>爱艺术老师端平台VIP专享的视频内容，但您理解并同意，除VIP专享内容外仍有少量视频出于版权方等原因需要您额外付费后方可观看</span>
          <span>，</span>
          <span>如这些服务内容在您付费成功后有一定期限的使用有效期（具体以购买页面说明为准），建议您及时使用，在有效期满后，无论您是否使用完毕所购的服务内容，爱艺术老师端不因此向您退还您已支付的费用且不予进行任何形式的补偿/赔偿。同时您理解并同意，就前述额外付费的部分或全部视频内容，爱艺术老师端有权根据自身运营需要，在一段时间后，免费提供给用户观看。</span>
        </p>
        <p>
          <span>3.2【服务开通】</span>
        </p>
        <p>
          <span>3.2.1您应该通过爱艺术老师端已有的和未来新增的渠道成为爱艺术老师端VIP会员，包括但不限于：通过支付宝、微信或第三方支付等方式成为VIP会员,在依约支付一定费用后开通和使用本服务以及参与面向VIP会员的活动。本服务开通之后，不可进行转让、赠与、借用、租用、销售。同时，您不得通过以下任何方式为自己或他人开通和使用本服务和/或参与相关活动：</span>
        </p>
        <p>
          <span>（1）以营利、经营等非个人使用的目的为自己或他人开通和使用本服务；</span>
        </p>
        <p>
          <span>（2）通过任何机器人软件、蜘蛛软件、爬虫软件、刷数据软件等任何程序、软件方式为自己或他人开通和使用本服务或获取VIP会员内容、数据；</span>
        </p>
        <p>
          <span>（3）未经爱艺术老师端事先明确许可，</span>
          <span>对</span>
          <span>爱艺术老师端</span>
          <span>用于保护</span>
          <span>VIP会员服务的任何安全措施技术进行破解、更改、反操作、篡改或其他破坏；未经爱艺术老师端</span>
          <span>事先书面同意而删除</span>
          <span>VIP会员服务内容上的任何所有权或知识产权声明或标签；</span>
        </p>
        <p>
          <span>（4）</span>
          <span>未经</span>
          <span>爱艺术老师端事先</span>
          <span>明确授权，采用收费或免费的方式，在任何公开场合全部或部分展示</span>
          <span>VIP会员服务内容（但如您的上述行为不构成侵权的除外）；</span>
        </p>
        <p>
          <span>（5）通过任何不正当手段或以违反诚实信用原则的方式为自己或他人开通本服务（如利用规则漏洞、利用系统漏洞、滥用会员身份、黑色产业、投机等违背爱艺术老师端提供服务/举办活动的初衷的方式）；</span>
        </p>
        <p>
          <span>（6）通过非爱艺术老师端指定的方式为自己或他人开通本服务；</span>
        </p>
        <p>
          <span>（7）通过侵犯爱艺术老师端或他人合法权益的方式为自己或他人开通本服务；</span>
        </p>
        <p>
          <span>（8）通过其他违反相关法律、行政法规、国家政策等的方式为自己或他人开通本服务。</span>
        </p>
        <p>
          <span>特别提示：开通本VIP会员服务后，您可以在最多五个设备（“设备”指包括但不限于计算机及移动电话、平板电脑等手持移动终端设备，下同）上使用您的会员账号，同一时间内仅可最多在</span>
          <span>一</span>
          <span>个设备上使用您的账号。超过上述范围使用的，爱艺术老师端有权中止或终止对您的服务并取消VIP会员资格，</span>
          <span>若您的VIP账号被封禁的，</span>
          <span>爱艺术老师端</span>
          <span>有权不经通知直接收回该账号使用权、取消该账号VIP会员资格，并不予退还VIP会员服务费且不予支付任何形式的赔偿/补偿</span>
          <span>，您应自行承担超范围使用而导致的任何损失。同时爱艺术老师端保留追究上述超范围使用行为人法律责任的权利。</span>
        </p>
        <p>
          <span>3.3【服务期限】</span>
        </p>
        <p>
          <span>3.3.1本服务的服务期限以您自行选择并支付相应服务费用的期限为准，您也可以登陆爱艺术老师端</span>
          <span>VIP页面</span>
          <span>或者本服务的相应页面查询。会员服务到期后，会员服务期间所提供的服务将不再享有</span>
          <span>。</span>
        </p>
        <p>
          <span>3.3.2本服务的服务开通最高期限为</span>
          <span>2</span>
          <span>年，用户会员服务有效期大于</span>
          <span>2</span>
          <span>年时无法继续开通本服务。具体以爱艺术老师端制定的的规则为准。</span>
        </p>
        <p>
          <span>3.</span>
          <span>4</span>
          <span>【行为规范】</span>
        </p>
        <p>
          <span>3.</span>
          <span>4.</span>
          <span>1【五不准】</span>
        </p>
        <p>
          <span>您在使用本服务时不得利用本服务从事以下行为，包括但不限于：</span>
        </p>
        <p>
          <span>（1）发布、传送、传播、储存违反国家法律、危害国家安全统一、社会稳定、公序良俗、社会公德以及侮辱、诽谤、淫秽、暴力的内容；</span>
        </p>
        <p>
          <span>（2）发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</span>
        </p>
        <p>
          <span>（3）虚构事实、隐瞒真相以误导、欺骗他人；</span>
        </p>
        <p>
          <span>（4）发表、传送、传播广告信息及垃圾信息；</span>
        </p>
        <p>
          <span>（5）从事其他违反法律法规、政策及公序良俗、社会公德等的行为。</span>
        </p>
        <p>
          <span>3.</span>
          <span>4</span>
          <span>.2【用户禁止行为】</span>
        </p>
        <p>
          <span>本服务仅供您个人使用，爱艺术老师端提供的VIP会员服务不得用于商业、盈利用途。除非经爱艺术老师端事先书面许可，您不得进行以下行为：</span>
        </p>
        <p>
          <span>（1）将本服务再次许可他人使用，并允许他人通过您的账户收听、下载非他人付费购买的VIP会员服务提供的音频作品；</span>
        </p>
        <p>
          <span>（2）将VIP会员服务提供的音频作品进行复制、下载、上传、修改、编目排序、翻译、发行、开发、转让、传播、销售、展示、出租、合成、嵌套、链接或授权给任何第三方；</span>
        </p>
        <p>
          <span>（3）通过本服务发布包含广告、宣传、促销等内容的信息；</span>
        </p>
        <p>
          <span>（4）通过任何方式搜集本服务中其他用户的用户名、用户账户、电子邮件、手机号码等相关信息，并以发送垃圾邮件、连锁邮件、垃圾短信、即时消息等方式干扰、骚扰其他用户损害第三方利益，包括但不限于隐私权、知识产权、财产权等；</span>
        </p>
        <p>
          <span>（5）利用VIP会员服务提供的音频进行创作衍生作品、进行教学或研究、进行商业开发或推广等；</span>
        </p>
        <p>
          <span>（6）利用非法手段对VIP会员账户的服务期限、消费金额、交易状态进行更改，或用非法的方式或非法的目的使用已购买的会员服务提供的音频；</span>
        </p>
        <p>
          <span>（7）其他未经爱艺术老师端书面许可的行为。</span>
        </p>
        <p>
          <span>3.</span>
          <span>4</span>
          <span>.3【对自己行为负责】</span>
        </p>
        <p>
          <span>您充分了解并同意，您必须为自己注册帐号下的一切行为负责，包括但不限于您所发表的任何内容（不限于图片、音频、文字等形式）以及由此产生的任何后果。您应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。</span>
        </p>
        <p>
          <span>3.</span>
          <span>5</span>
          <span>【服务的变更、中止或终止】</span>
        </p>
        <p>
          <span>3.5.1.您理解并认可：您仅拥有合法获得爱艺术老师端VIP会员服务的使用权，上述服务、产品及其衍生物的所有权或相关知识产权均归爱艺术老师端所有。爱艺术老师端有权根据实际情况自行决定您的使用期限及/或终止期限而无需通知您，亦无需征得您同意，您不予追究或者豁免爱艺术老师端的相关法律责任。</span>
        </p>
        <p>
          <span>3.</span>
          <span>5</span>
          <span>.2爱艺术老师端可能对本VIP会员服务协议进行不定期修改，协议修改后，爱艺术老师端将在相关页面或以其他合适的方式公布修改的内容。如果您不同意本协议的修改，请立即停止使用平台或取消已经获得的服务；如果您选择在本协议修改后继续访问或使用平台或服务的，则视为您已接受本协议的修改。</span>
        </p>
        <p>
          <span>您与爱艺术老师端签署的本协议所列明的条款，并不能完全涵盖您与浙江艺高文化创意有限公司所有的关于VIP会员服务的权利和义务。因此，爱艺术老师端公布其他声明、各形式规则均视为本协议之补充条款，为本协议不可分割的组成部分，与本协议具有同等法律效力。</span>
        </p>
        <p>
          <span>未经您明确同意，我们不会限制您按照本协议所应享有的权利。我们会在爱艺术老师端平台专门链接上发布对VIP会员服务协议所做的任何变更和更新。 对于重大变更，我们还会提供更为显著的通知（包括我们会通过我方平台公示的方式进行通知甚至向您提供弹窗提示）。</span>
        </p>
        <p>
          <span>3.6.3您充分了解并同意，由于互联网服务的特殊性或不可抗拒的事由，如政府行为、不可抗力、导致VIP会员服务无法继续，爱艺术老师端会按照相关法规、双方约定或在其他必要时，中止或终止向您提供本服务，并以最快的方式通知VIP会员，但不承担由此对VIP会员造成的任何损失。</span>
        </p>
        <p>
          <span>3.6.4爱艺术老师端应按照本协议之约定向您提供会员服务。若在您购买会员后，因爱艺术老师端过错导致您未能享受会员权益的，爱艺术老师端应对您予以补偿，您可以联系爱艺术老师端客服</span>
          <span>，</span>
          <span>拨打客服电话：400</span>
          <span>9</span>
          <span>-260-658与我们联系。</span>
        </p>
        <p>
          <span>四、【违约责任】</span>
        </p>
        <p>
          <span>4.1如果爱艺术老师端发现或收到他人举报您有违反本协议任何行为的，爱艺术老师端有权依法进行独立判断并采取技术手段予以删除、屏蔽、下架，对于用户账号实施禁言、撤V、封号等处理措施。同时，爱艺术老师端有权视您的行为性质，对您采取包括但不限于暂停或终止部分或全部本服务、中止或终止您对爱艺术老师端用户账户的使用、追究您法律责任等措施，爱艺术老师端也无需向您退还任何费用，而由此给您带来的损失（包括但不限于通信中断、相关数据清空、未使用的服务费用作为违约金而归爱艺术老师端所有等），由您自行承担。如您的违约行为造成浙江艺高文化创意有限公司和/或其关联公司损失（包括但不限于自身的直接经济损失、商誉损失及对外支付的赔偿金、和解金、律师费、诉讼费等间接经济损失）的，您应当赔偿艺高及其关联公司的前述全部损失。</span>
        </p>
        <p>
          <span>4.2【对第三方损害的处理】</span>
        </p>
        <p>
          <span>您有违反本协议任何行为，导致任何第三方损害的，您应当独立承担责任；爱艺术老师端因此遭受损失的，您也应当一并赔偿。</span>
        </p>
        <p>
          <span>五、【未成年人的保护】</span>
        </p>
        <p>
          <span>5.1【未成年人的使用前提】</span>
        </p>
        <p>
          <span>艺高公司非常注重未成年人的保护。若您为未成年人的，应在监护人监护、指导下阅读本协议，并且使用VIP会员服务已经得到监护人的同意。</span>
        </p>
        <p>
          <span>5.2【监护人的同意】</span>
        </p>
        <p>
          <span>监护人应指导子女上网应该注意的安全问题，防患于未然。若监护人同意未成年人使用VIP会员服务，必须以监护人名义申请消费，并对未成年人使用VIP会员服务进行正确引导、监督。</span>
          <span>未成年人使用VIP会员服务，以及行使和履行本协议项下的权利和义务即视为已获得了监护人的同意</span>
          <span>。</span>
        </p>
        <p>
          <span>六、【其他】</span>
        </p>
        <p>
          <span>6.1【协议的生效】</span>
        </p>
        <p>
          <span>您使用本服务即视为您已阅读并同意受本协议的约束。</span>
        </p>
        <p>
          <span>6.2【协议签订地】</span>
        </p>
        <p>
          <span>本协议签订地为中华人民共和国</span>
          <span>浙江省杭州市</span>
          <span>西湖区。</span>
        </p>
        <p>
          <span>6.3【适用法律即条款效力】</span>
        </p>
        <p>
          <span>本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</span>
        </p>
        <p>
          <span>6.4【争议解决】</span>
        </p>
        <p>
          <span>您与浙江艺高文化创意有限公司或爱艺术老师端平台发生的一切争议，应友好协商，如协商不成的，可选择按下述任一途径解决：</span>
        </p>
        <p>
          <span>（一） 提交杭州仲裁委员会，按照申请仲裁时现行有效的仲裁规则进行仲裁；仲裁裁决为终局裁决，对各方均有约束力；</span>
        </p>
        <p>
          <span>（二） 提交协议签订地人民法院诉讼管辖；</span>
        </p>
        <p>
          <span>6.5【条款标题】</span>
        </p>
        <p>
          <span>本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</span>
        </p>
        <p>
          <span>&#xa0;</span>
        </p>
        <p>
          <span>&#xa0;</span>
        </p>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "爱艺术老师端VIP会员服务协议",
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
main {
  color: #333;
  .wrapper {
    background: #fff;
    border-radius: 10px;
    padding: 16px;
    span {
      font-size: 14px;
      line-height: 28px;
    }
  }
}
</style>